import { render, staticRenderFns } from "./AccountSettingCurrencyPrice.vue?vue&type=template&id=04849a2d"
import script from "./AccountSettingCurrencyPrice.vue?vue&type=script&lang=js"
export * from "./AccountSettingCurrencyPrice.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingCurrencyPrice.vue?vue&type=style&index=0&id=04849a2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports